import { render } from "./breadCrumb.vue?vue&type=template&id=71626333&scoped=true&ts=true"
import script from "./breadCrumb.vue?vue&type=script&lang=ts"
export * from "./breadCrumb.vue?vue&type=script&lang=ts"

import "./breadCrumb.vue?vue&type=style&index=0&id=71626333&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71626333"]])

export default __exports__